import FormatError from '../system/FormatError';
export default class DefaultNumberParser {
    constructor(numberFormatInfo) {
        this.numberFormatInfo = numberFormatInfo;
    }
    parse(value) {
        const result = this.tryParse(value);
        if (result === undefined) {
            throw new FormatError(`'${value}' does not represent a number in a valid format.`);
        }
        return result;
    }
    tryParse(value, valueOnFailure = undefined) {
        if (value === undefined || value === null) {
            return valueOnFailure;
        }
        else if (typeof (value) === 'number') {
            return value;
        }
        else {
            value = value.trim()
                .replace(this.numberFormatInfo.negativeSign, '-')
                .replace(this.numberFormatInfo.numberGroupSeparator, '')
                .replace(this.numberFormatInfo.numberDecimalSeparator, '.')
                .replace(new RegExp(this.numberFormatInfo.nativeDigits.join(''), 'g'), val => this.numberFormatInfo.nativeDigits[this.numberFormatInfo.nativeDigits.indexOf(val)]);
            const result = Number(value);
            if (typeof (value) !== 'number') {
                return valueOnFailure;
            }
            else {
                return result;
            }
        }
    }
}
//# sourceMappingURL=DefaultNumberParser.js.map